var crateNumber = 3;
var variantTitle = 'Youth Medium'
class giftSubscription {
    constructor(){
        this._isUpdatingDropdowns = false;
        document.querySelectorAll("[data-select-gift]").forEach(ele=>{
            ele.addEventListener("change" , (event)=>{
                if (!this._isUpdatingDropdowns) {
                    this._chooseCrateNumber(event);
                }
            })
        });
        document.querySelectorAll("[data-select-size]").forEach(ele=>{
            ele.addEventListener("change" , (event)=>{
                this._chooseShirtSize(event);
            })
        });

        document.querySelector("[data-atc-btn]").addEventListener("click",(event)=>{
            
            this._addToCart(event);
        });

        // Set initial state based on default selected option
        document.querySelectorAll("[data-select-gift]").forEach(ele=>{
            if (ele.selectedIndex >= 0) {
                this._updateTshirtVisibility(ele);
            }
        });

        // Initialize variantTitle from visible T-shirt dropdown
        let visibleWrapper = Array.from(document.querySelectorAll(".gift-product-wrapper")).find(wrapper => {
            let style = wrapper.getAttribute("style") || "";
            return style.includes("display:block") || (!style.includes("display:none") && window.getComputedStyle(wrapper).display !== "none");
        });
        
        if (visibleWrapper) {
            let visibleTshirtSelect = visibleWrapper.querySelector("[data-select-size]");
            let tshirtContainer = visibleWrapper.querySelector("[data-tshirt-container]");
            
            // Only get value if container is visible
            if (visibleTshirtSelect && tshirtContainer && 
                window.getComputedStyle(tshirtContainer).display !== "none" &&
                visibleTshirtSelect.options.length > 0) {
                variantTitle = visibleTshirtSelect.value;
            }
        }
        
        // Fallback: get first available T-shirt select
        if (!variantTitle || variantTitle === 'Youth Medium') {
            let firstTshirtSelect = document.querySelector("[data-select-size]");
            if (firstTshirtSelect && firstTshirtSelect.options.length > 0) {
                variantTitle = firstTshirtSelect.value;
            }
        }

    }
    _chooseCrateNumber(event){
        let currentEle = event.currentTarget;
        let selectedValue = currentEle.value;
        let selectedIndex = currentEle.selectedIndex;
        let selectedOption = currentEle.options[selectedIndex];
        
        // Update visibility first
        this._updateTshirtVisibility(currentEle);
        
        // Use requestAnimationFrame to ensure DOM has updated before syncing dropdowns
        requestAnimationFrame(() => {
            // Prevent recursive updates when syncing dropdowns
            this._isUpdatingDropdowns = true;
            
            // Sync all dropdowns to show the same selected value
            document.querySelectorAll("[data-select-gift]").forEach(dropdown => {
                if (dropdown.value !== selectedValue) {
                    dropdown.selectedIndex = selectedIndex;
                }
            });
            
            this._isUpdatingDropdowns = false;
        });
        
        crateNumber = parseInt(selectedOption.getAttribute("data-crate-number"));
        let discount = parseInt(selectedOption.getAttribute("data-discount"));
        let subTotal = selectedOption.getAttribute("data-price");
        
        document.querySelector("[gift_sub_total]").innerHTML = subTotal;
        let unitPrice = selectedOption.getAttribute("product_unit_price");
        document.querySelector("[gift_price]").innerHTML = unitPrice;
        if (discount == 0 ) {
            document.querySelector("[total_discount]").innerHTML = 'no saving';
            document.querySelector("[total_discount]").classList.remove("savings");
        }else{
            document.querySelector("[total_discount]").innerHTML = `save ${discount}%`;
            document.querySelector("[total_discount]").classList.add("savings");
        }
    };

    _updateTshirtVisibility(selectElement){
        if (selectElement.selectedIndex < 0) return;
        
        let selectedOption = selectElement.options[selectElement.selectedIndex];
        let selectedValue = selectElement.value;
        let productId = selectedOption.getAttribute("data-crate");
        let showTshirtAttr = selectedOption.getAttribute("data-show-tshirt");
        // Handle boolean values: 'true', true, '1', 'yes', or null/empty (defaults to true)
        let showTshirt = showTshirtAttr === 'true' || showTshirtAttr === '1' || showTshirtAttr === 'yes' || showTshirtAttr === null || showTshirtAttr === '';

        // Show/hide product wrappers based on selected product
        let activeWrapper = null;
        document.querySelectorAll(".gift-product-wrapper").forEach(wrapper => {
            if (wrapper.getAttribute("data-product-id") === productId) {
                wrapper.style.display = "block";
                activeWrapper = wrapper;
                
                // Ensure the dropdown in the active wrapper has the correct selected value
                let wrapperDropdown = wrapper.querySelector("[data-select-gift]");
                if (wrapperDropdown) {
                    let currentSelectedIndex = selectElement.selectedIndex;
                    if (wrapperDropdown.selectedIndex !== currentSelectedIndex) {
                        this._isUpdatingDropdowns = true;
                        wrapperDropdown.selectedIndex = currentSelectedIndex;
                        this._isUpdatingDropdowns = false;
                    }
                }
            } else {
                wrapper.style.display = "none";
            }
        });

        // Show/hide T-shirt dropdown based on selected option
        document.querySelectorAll("[data-tshirt-container]").forEach(container => {
            let parentWrapper = container.closest(".gift-product-wrapper");
            // Only show T-shirt dropdown in the active wrapper
            if (parentWrapper === activeWrapper && activeWrapper !== null) {
                container.style.display = showTshirt ? "block" : "none";
            } else {
                container.style.display = "none";
            }
        });
    };

    _chooseShirtSize(event){
        let currentEle = event.currentTarget;
        variantTitle = currentEle.value;
    };

   async _addToCart(event){
        event.stopImmediatePropagation();
     
        event.currentTarget.classList.add("loading");
        
        // Get current crate selection from visible dropdown
        let currentCrateNumber = null;
        let visibleWrapper = Array.from(document.querySelectorAll(".gift-product-wrapper")).find(wrapper => {
            let style = wrapper.getAttribute("style") || "";
            return style.includes("display:block") || (!style.includes("display:none") && window.getComputedStyle(wrapper).display !== "none");
        });
        
        if (!visibleWrapper) {
            this._showError("Please select a crate option.");
            event.currentTarget.classList.remove("loading");
            return;
        }
        
        // Get the selected crate number from the visible dropdown
        let crateDropdown = visibleWrapper.querySelector("[data-select-gift]");
        if (!crateDropdown || crateDropdown.selectedIndex < 0) {
            this._showError("Please select a crate option.");
            event.currentTarget.classList.remove("loading");
            return;
        }
        
        let selectedCrateOption = crateDropdown.options[crateDropdown.selectedIndex];
        currentCrateNumber = parseInt(selectedCrateOption.getAttribute("data-crate-number"));
        let productId = selectedCrateOption.getAttribute("data-crate");
        
        // Get the currently selected T-shirt size from the visible dropdown
        let selectedTshirtSize = null;
        let tshirtContainer = visibleWrapper.querySelector("[data-tshirt-container]");
        let tshirtSelect = visibleWrapper.querySelector("[data-select-size]");
        
        // Check if T-shirt container is visible and get selected value
        if (tshirtContainer && tshirtSelect) {
            let isVisible = tshirtContainer.style.display !== 'none' && 
                           window.getComputedStyle(tshirtContainer).display !== "none";
            
            if (isVisible) {
                selectedTshirtSize = tshirtSelect.value;
                
                // Validate that a T-shirt size is actually selected
                if (!selectedTshirtSize || selectedTshirtSize.trim() === '') {
                    this._showError("Please select a T-shirt size.");
                    event.currentTarget.classList.remove("loading");
                    return;
                }
            }
        }
        
        // If T-shirt dropdown is hidden, check if it should be visible
        if (!selectedTshirtSize) {
            let showTshirtAttr = selectedCrateOption.getAttribute("data-show-tshirt");
            let showTshirt = showTshirtAttr === 'true' || showTshirtAttr === '1' || showTshirtAttr === 'yes' || showTshirtAttr === null || showTshirtAttr === '';
            
            if (showTshirt) {
                this._showError("Please select a T-shirt size.");
                event.currentTarget.classList.remove("loading");
                return;
            }
            // If T-shirt is not required, use stored variantTitle as fallback
            selectedTshirtSize = variantTitle;
        }
        
        // Find the correct variant data based on crate number
        let variantScript = null;
        document.querySelectorAll("[data-main-product-variant]").forEach(ele => {
            let crateNum = parseInt(ele.getAttribute("data-crate-ship"));
            if (crateNum === currentCrateNumber) {
                variantScript = ele;
            }
        });
        
        if (!variantScript) {
            this._showError(`No variant data found for ${currentCrateNumber} crate option. Please try again.`);
            event.currentTarget.classList.remove("loading");
            return;
        }
        
        let allVariants = [];
        try {
            allVariants = JSON.parse(variantScript.innerText);
        } catch (e) {
            console.error("Error parsing variant data:", e);
            this._showError("Error loading product data. Please refresh the page and try again.");
            event.currentTarget.classList.remove("loading");
            return;
        }
        
        if (!allVariants || allVariants.length === 0) {
            this._showError(`No variants available for ${currentCrateNumber} crate option.`);
            event.currentTarget.classList.remove("loading");
            return;
        }
        
        // Match T-shirt size against the variant's size metafield
        let matchedVariant = allVariants.find(x => x.size && x.size.trim() === selectedTshirtSize.trim());
        
        // If no match found, try matching against variant_title as fallback
        if (!matchedVariant) {
            matchedVariant = allVariants.find(x => x.variant_title && x.variant_title.trim() === selectedTshirtSize.trim());
        }
        
        // CRITICAL: Never use fallback variant - show error if no match found
        if (!matchedVariant) {
            let availableSizes = allVariants.map(v => v.size).filter(s => s).join(", ");
            this._showError(`Selected T-shirt size "${selectedTshirtSize}" is not available for this crate option. Available sizes: ${availableSizes || "None"}`);
            event.currentTarget.classList.remove("loading");
            return;
        }
        
        // Validate matched variant has all required fields
        if (!matchedVariant.variant_id || !matchedVariant.subscription_id || !matchedVariant.selling_plan_id) {
            this._showError("Product variant data is incomplete. Please refresh the page and try again.");
            event.currentTarget.classList.remove("loading");
            return;
        }
        
        console.log("Matched variant:", matchedVariant);
        console.log("Selected T-shirt size:", selectedTshirtSize);
        console.log("Crate number:", currentCrateNumber);
        
        let variantId = parseInt(matchedVariant.variant_id);
        let subscription_Id = parseInt(matchedVariant.subscription_id);
        let selling_plan_id = parseInt(matchedVariant.selling_plan_id);
        
        // Final validation before adding to cart
        if (!variantId || !subscription_Id || !selling_plan_id) {
            this._showError("Invalid product data. Please refresh the page and try again.");
            event.currentTarget.classList.remove("loading");
            return;
        }
        
        let subscriptionData = {};
        subscriptionData['No of Crate'] = `${currentCrateNumber}`;
        subscriptionData['is_subscrption'] = true; 
        subscriptionData['First Crate SKU'] = `${window.current_month_crate_sku}-${matchedVariant.size}`;

        // Block ATC and redirect when First Crate SKU is exactly "surprise"
        if (subscriptionData['First Crate SKU'] === 'surprise') {
            event.currentTarget.classList.remove("loading");
            window.location.href = '/pages/join-the-team';
            return;
        }

        let items = [{
            quantity: 1,
            id: variantId,
            properties: subscriptionData,
            selling_plan: selling_plan_id
        }];

        var requestData = {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({items: items}),
        };
        
        fetch('/cart/add.js', requestData)
        .then(async response => {
            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }
            let data = await response.json();
            let currentEle = document.querySelector("[data-submit-subscription]");
            if (currentEle) {
                currentEle.classList.remove("loading");
            }
            window.location.href = "/cart";
        })
        .catch(e => {
            console.error("Error adding to cart:", e);
            this._showError("Failed to add product to cart. Please try again.");
            let currentEle = document.querySelector("[data-submit-subscription]");
            if (currentEle) {
                currentEle.classList.remove("loading");
            }
        });
    }

    _showError(message){
        // Remove any existing error messages
        let existingError = document.querySelector(".gift-page-error");
        if (existingError) {
            existingError.remove();
        }
        
        // Create error message element
        let errorDiv = document.createElement("div");
        errorDiv.className = "gift-page-error alert alert-danger";
        errorDiv.style.cssText = "margin: 15px 0; padding: 12px; background-color: #f8d7da; color: #721c24; border: 1px solid #f5c6cb; border-radius: 4px;";
        errorDiv.textContent = message;
        
        // Insert error message before the add to cart button
        let atcButton = document.querySelector("[data-atc-btn]");
        if (atcButton && atcButton.parentElement) {
            atcButton.parentElement.insertBefore(errorDiv, atcButton);
        } else {
            // Fallback: append to product details wrapper
            let productWrapper = document.querySelector(".product-details-wrapper");
            if (productWrapper) {
                productWrapper.appendChild(errorDiv);
            }
        }
        
        // Auto-remove error after 5 seconds
        setTimeout(() => {
            if (errorDiv.parentElement) {
                errorDiv.remove();
            }
        }, 5000);
    }
  }
  new giftSubscription();

